import { chatActions } from "./types";

const countReadable = (count) => {
    return { 
        type: chatActions.CHAT_COUNT_READABLE, 
        payload: { count } 
    };
};

const chatAction = {
    countReadable,
}

export default chatAction;
